import DialogProvider from "@components/dialog_provider"
import { oneTimesUpdate } from "@domain/coupons"
import useTranslate from "@hooks/use_translate"
import { Stack, Typography } from "@mui/material"
import { showErrorToast, showSuccessToast } from "@utils/toast"
import { OneTimesType } from "__generated__/graphql"
import { useState } from "react"

type CreateDefaultSystemReportsProps = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export default function CreateDefaultSystemReports({
  isOpen,
  setIsOpen
}: CreateDefaultSystemReportsProps) {
  const { translate } = useTranslate()
  const [loading, setLoading] = useState(false)

  const handleClose = () => {
    if (loading) {
      return
    }
    setIsOpen(false)
  }

  async function onSubmit() {
    setLoading(true)
    const {
      isSuccess,
      errorMessage,
      data: responseData
    } = await oneTimesUpdate({
      type: OneTimesType.CreateDefaultSystemReports,
      metaData: {}
    })

    if (!isSuccess || !responseData) {
      setLoading(false)
      showErrorToast(String(errorMessage))
      return
    }

    showSuccessToast("Default system reports created.")
    setLoading(false)
    setIsOpen(false)
  }

  return (
    <DialogProvider
      title="Create Default System Reports"
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: handleClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("submit"),
        color: "primary",
        onClick: onSubmit,
        loading: loading,
        disabled: loading
      }}
      isOpen={isOpen}
      setClose={handleClose}
      size="small"
    >
      <Stack gap={1}>
        <Typography variant="body2">
          This will create the default system reports. Are you sure you want to
          continue?
        </Typography>
      </Stack>
    </DialogProvider>
  )
}
